import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Navigation
import { useNavigate, Navigate, useParams, Link } from 'react-router-dom';

// Image
import ModalImage from "react-modal-image";

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

@inject('AuthStore', 'TrainingStore')
@observer

class ViewTraining extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const details = this.props.TrainingStore.trainings[this.props.id];
        const storeId: any = localStorage.getItem('storeId');
        
        return (
            this.props.AuthStore.userData.isLogin ?
                storeId !== null ?
                    <CommerceLayout
                        title={Helpers.translation('view')}
                        visibleCategories={false}
                    >
                        <section id="shop">
                            <div className="container mx-auto p-4">
                                <div className="flex flex-col">
                                    <div className="w-full mt-4">
                                        {
                                            details !== undefined &&
                                            <div>
                                                <div className="font-bold text-lg mb-2">{Helpers.translation(details.title)}</div>

                                                {
                                                    details.contents.map((content: any, index: number) => {
                                                        let documentData: any = null;
                                                        let mimeType: any = "application";

                                                        if (content.documentId !== null) {
                                                            const documentIndex = Helpers.findIndexByCriteria(details.documents.data, "id", content.documentId);
                                                            documentData = details.documents.data[documentIndex];
                                                            mimeType = documentData.attributes.mime.split("/")[0];
                                                        }

                                                        return (
                                                            <div
                                                                key={index}
                                                                className="mb-2"
                                                            >
                                                                {
                                                                    content.title !== "" &&
                                                                    <div className="font-bold">{content.title}</div>
                                                                }

                                                                {
                                                                    content.description !== "" &&
                                                                    <div>{content.description}</div>
                                                                }

                                                                {
                                                                    (documentData !== null && documentData !== undefined) &&
                                                                    <div>
                                                                        {
                                                                            mimeType === "image" &&
                                                                            <ModalImage
                                                                                small={Helpers.getMediumImageUrl(documentData.attributes)}
                                                                                large={Helpers.getBiggestImageUrl(documentData.attributes)}
                                                                                className="w-96 border border-black"
                                                                            />
                                                                        }

                                                                        {
                                                                            mimeType === "application" &&
                                                                            <Link to={`${Helpers.getBiggestImageUrl(documentData.attributes)}`}>
                                                                                <div>
                                                                                    <span>{Helpers.translation('document')}</span> : <span className="text-blue-600">{documentData.attributes.name}</span>
                                                                                </div>
                                                                            </Link>
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </section>
                    </CommerceLayout>
                    :
                    <Navigate to="/" replace={true} />
                :
                <Navigate to="/login" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    const { id } = useParams();

    props = {
        ...props,
        id
    }

    return <ViewTraining {...props} navigate={navigate} />
}

export default WithNavigate